module.exports = [function ($rootScope, $timeout, $window) {
  return {
    restrict: 'E',
    scope: true,
    replace: true,
    controller: ["$scope", "UserProfileSvc", function ($scope, UserProfileSvc) {
      $scope.tryNewApp = function () {
        UserProfileSvc.tryNewDesign().then(function (result) {
          const currentLocation = window.location.href;
          if (currentLocation.indexOf('/dashboard') !== -1) {
            window.location.replace('/app/');
          } else if (currentLocation.indexOf('/accounts') !== -1) {
              window.location.replace('/app/profile');
          } else if (currentLocation.indexOf('/plant/') !== -1) {
            const index = currentLocation.indexOf('/plant/');
            const url = currentLocation.slice(index);
            window.location.replace(`/app${url}`);
          } else if (currentLocation.indexOf('/reports') !== -1) {
            window.location.replace('/app/reports/');
          }
        });
      };
    }],
    templateUrl: '/static/partials/try_new_app.html',
    link: function ($scope, $element, attrs) {

    }
  };
}];